export enum AppTheme {
  System = "system",
  Light = "light",
  Dark = "dark",
}
export type ThemeColor = { DEFAULT: string; dark: string };
